export default [
  {
    active: true,
    description: 'ATIVAR AÇÃO',
    tipo: 'ativarRegra',
    rota_id: '',
    regex_id: '',
  },
  {
    active: true,
    description: 'DESATIVAR AÇÃO',
    tipo: 'desativarRegra',
    rota_id: '',
    regex_id: '',
  },
  {
    active: true,
    description: 'LOGAR AGENTE',
    tipo: 'logarAgente',
    agente_id: '',
    ramal: '',
    agente_name: '',
  },
  {
    active: true,
    description: 'DESLOGAR AGENTE',
    tipo: 'deslogarAgente',
    agente_id: '',
    agente_name: '',
  },
  {
    active: true,
    description: 'DESLOGAR DEPARTAMENTO',
    tipo: 'deslogarDepartamento',
    departament_id: '',
    departament_name: '',
  },
  {
    active: true,
    description: 'BACKUP',
    tipo: 'backup',
    backup_total: '',
    backup_opc: '',
  },
]
